// order.interface.ts
import { BusinessHub } from "./hub";

export enum OrderStatus {
  Pending = 'Pending',
  Confirmed = 'Confirmed',
  ReadyForPickup = 'Ready for Pickup',
  OutForDelivery = 'Out for Delivery',
  Completed = 'Completed',
  Cancelled = 'Cancelled'
}

export enum DeliveryMethod {
  ClickAndCollect = 'Click and Collect',
  Delivery = 'Delivery',
  Digital = 'Digital'
}

export enum PaymentStatus {
  Pending = 'Pending',
  Paid = 'Paid',
  Failed = 'Failed',
  Refunded = 'Refunded'
}

export interface OrderItem {
  productId: number;
  productName: string;
  sku: string;
  price: number;
  quantity: number;
  smartCoins: number;
  imageUrl?: string;
  discount?: number;
  isTicket?: boolean;
}

export interface Order {
  id: number;
  orderNumber: string;
  trackingUrl?: string;
  // Customer info
  customerId: string;
  customerName: string;
  customerEmail?: string;
  customerPhone?: string;
  
  // Business hub
  businessHubId: number;
  business_hub?: BusinessHub;
  
  // Delivery
  deliveryMethod: DeliveryMethod;
  pickupTime?: Date;
  deliveryAddress?: string;
  deliveryCity?: string;
  deliveryPostal?: string;
  deliveryTime?: Date;
  deliveryFee: number;
  
  // Items
  items: OrderItem[];
  
  // Pricing
  subtotal: number;
  smartCoinsUsed: number;
  smartCoinsDiscount: number;
  totalPrice: number;
  smartCoinsEarned: number;
  
  // Status
  status: OrderStatus;
  paymentStatus: PaymentStatus;
  
  // Stripe tracking
  stripePaymentIntentId?: string;
  stripeRefundId?: string;
  
  // Refund info
  refundedAt?: Date;
  refundReason?: string;
  cancellationSource?: string;
  applicationFeeRefunded?: boolean;
  
  // Invoice
  invoiceNumber?: string;
  invoiceUrl?: string;
  
  // Notes
  customerNotes?: string;
  internalNotes?: string;
  
  // Timestamps
  createdAt: Date;
  updatedAt?: Date;
  completedAt?: Date;
  
  // Demo flag
  isDemo: boolean;
  
  // Computed fields
  totalItemsCount?: number;
  totalProductsCount?: number;
  canBeCancelled?: boolean;
  hasInvoice?: boolean;
}

export interface CreateOrderRequest {
  orders: CreateSubOrder[];
  smartCoinsUsed?: number
}

export interface CreateSubOrder {
  businessHubId: number;
  deliveryMethod: DeliveryMethod;
  pickupTime?: string;
  deliveryAddress?: string;
  deliveryCity?: string;
  deliveryPostal?: string;
  deliveryTime?: string;
  deliveryFee?: number;
  items: OrderItem[];
  smartCoinsUsed?: number;
  customerNotes?: string;
}

export interface OrderListResponse {
  orders: Order[];
  total: number;
  page: number;
  pages: number;
  hasMore: boolean;
}

export interface CreateOrderResponse {
  message: string;
  orders: Order[];
  totalOrders: number;
}